<template>
  <div
    class="loader-overlay"
    :style="`background: rgba(255, 255, 255, ${opacity});`"
    v-if="status"
  >
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: Boolean,
      default: false
    },
    opacity: {
      type: Number,
      default: 0.8
    }
  }
};
</script>

<style lang="scss" scoped>
.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0px;
  align-items: center;
  overflow: hidden;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  z-index: 5;
  border-radius: inherit;
}
</style>
